export enum CalendarEventTypes {
  Simple = 0,
  EmployeeMonthOverview = 1,
}
